import clearblade from '~/images/clearblade.png'
import { ImgHTMLAttributes } from 'react'

const ClearBladeLogo = (props: ImgHTMLAttributes<HTMLImageElement>) => (
  <img src={clearblade} {...props} alt="" />
)

export default ClearBladeLogo
